module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/confirmation-dialog/confirmation-dialog.component.css
// module id = ./src/app/shared/components/confirmation-dialog/confirmation-dialog.component.css
// module chunks = main